import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import type { PromptTemplateCategory } from '../../api';

interface CategoryManageModalProps {
  open: boolean;
  onClose: () => void;
  categories: PromptTemplateCategory[];
  onEdit: (cat: PromptTemplateCategory) => void;
  onDelete: (cat: PromptTemplateCategory) => void;
}

export default function CategoryManageModal({
  open,
  onClose,
  categories,
  onEdit,
  onDelete,
}: CategoryManageModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Управление категориями</DialogTitle>
      <DialogContent>
        <List>
          {categories.length === 0 ? (
            <ListItem>
              <ListItemText primary="Нет категорий" secondary="Добавьте категорию в каталоге" />
            </ListItem>
          ) : (
            categories.map((cat) => (
              <ListItem
                key={cat.id}
                secondaryAction={
                  <Box>
                    <IconButton
                      edge="end"
                      onClick={() => onEdit(cat)}
                      title="Редактировать"
                      size="small"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      edge="end"
                      onClick={() => onDelete(cat)}
                      title="Удалить"
                      size="small"
                      color="error"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                }
              >
                <Box
                  component="span"
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: 1,
                    bgcolor: cat.color,
                    mr: 1.5,
                    display: 'inline-block',
                  }}
                />
                <ListItemText primary={cat.title} secondary={cat.description} />
              </ListItem>
            ))
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
}
